module.exports = __webpack_public_path__ + "img/slider-4.c990047b.png";